import { connect } from 'react-redux'
import { createAuthStateToProps } from 'helpers/auth'

export default ({ actions, extraStateToProps, extraDispatchToProps } = {}) =>
  (Component) => {
    const mapStateToProps = (state, props) => ({
      ...createAuthStateToProps(state, props),
      ...(extraStateToProps ? extraStateToProps(state, props) : {}),
    })

    const mapDispatchToProps = (dispatch, props) => ({
      getSettings: (params) =>
        props.fieldSettings
          ? Promise.resolve({ value: { data: { fieldSettings: props.fieldSettings } } })
          : dispatch(actions.getSettings(params)),
      getItems: () => Promise.resolve({ value: { data: { items: props.items ?? [] } } }),
      ...(extraDispatchToProps ? extraDispatchToProps(dispatch, props) : {}),
    })

    return connect(mapStateToProps, mapDispatchToProps)(Component)
  }
